module.exports = __webpack_public_path__ + "static/img/2.c91a132a.png";